var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/message-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "message-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.08073 15.8337H6.66406C3.33073 15.8337 1.66406 15.0003 1.66406 10.8337V6.66699C1.66406 3.33366 3.33073 1.66699 6.66406 1.66699H13.3307C16.6641 1.66699 18.3307 3.33366 18.3307 6.66699V10.8337C18.3307 14.167 16.6641 15.8337 13.3307 15.8337H12.9141C12.6557 15.8337 12.4057 15.9587 12.2474 16.167L10.9974 17.8337C10.4474 18.567 9.5474 18.567 8.9974 17.8337L7.7474 16.167C7.61406 15.9837 7.30573 15.8337 7.08073 15.8337Z",
    stroke: "#2948A7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.83594 6.66699H14.1693",
    stroke: "#2948A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.83594 10.833H10.8359",
    stroke: "#2948A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.a0613c9fb79561896734f9bf68c1ec1d.svg";
export { ForwardRef as ReactComponent };